<section>
  <div class="canvas-anchor">
    <div
      class="canvas-area background-accent"
      #canvasAvailableArea
      [style.max-width]="canvasAreaWidth"
      [style.min-width]="canvasAreaWidth"
      [style.max-height]="canvasAreaHeight"
      [style.min-height]="canvasAreaHeight"
    ></div>

    <div class="canvas-float">
      <canvas id="timelineSurface"></canvas>
    </div>

    <tablesready-frontend-scrollbar
      [showVertical]="false"
      [noZoomWidth]="targetCanvasWidth"
      [canvasAreaWidth]="canvasAreaWidth"
      [canvasAreaHeight]="canvasAreaHeight"
    >
      <div [style.width.px]="scrollableAreaWidth" [style.height.px]="scrollableAreaHeight"></div>
    </tablesready-frontend-scrollbar>
  </div>

</section>
